module.exports = __webpack_public_path__ + "assets/img/select_products1.a379de4a.svg";